import React from "react";

const enTranslations = {
  "welcome": "Welcome",
    "workingHours": "Working Hours",
    "today": "Today",
    "clockIn": "Clock-In",
    "clockOut": "Clock-Out",
    "location": "Location",
    "inbox": "Inbox",
    "seemore": "See More",
    "totalworkforce":"Total Work Force",
    "attendancestatus" : "Attendance Status",
    "clockedinfromoffice" : "Clocked In From Office",
    "clockedinfromremote" : "Clocked In From Remote",
    "notyetclockedin" : "Not yet Clocked In",
    "chennaioffice" : "Chennai Office",
    "DubaiOffice" : "Dubai Office",
    "WorkForce" : "Work Force",
    "employeeslist" : "Employees List",
    "leave/absent" : "Leave/Absent",
    "leave" : "Leave",
    "absent" : "Absent",
    "onduty" : "On Duty",
    "atremote" : "At Remote",
    "atoffice" : "At Office",

    
    "knowmore" : "know More",
    "inboxItems": {
      "item1": "Smart Document",
      "item2": "Mom",
      "item3": "Meeting",
      "item4": "Tasks",
      "item5": "Smart Service"
    },
  "mostusedservice": "Most used services",
  "mostusedItem": {
    "item1": "Smart Service",
    "item2": "Meeting Calendar",
    "item3": "Task",
  },
  "knowledgehub": "Knowledge Hub",
    "knowledgeItem": {
      "item1": "Employee Directory",
      "item2": "Shared Folder",
      "item3": "Links & Videos",
      "item4": "My Report",
      "item5": "My Assets",
      "item6": "Groups"
    },
  "allmytasks": "All My Task",
  "notask": "No Task",
  "mytaskcard": "My Task Card",
  "entertasktitle" : "Enter task title",
  "entertaskdescription" : "Enter task description",
  "taskname": "Task Name",
  "assignedBy": "Assigned By",
  "assignedto": "Assigned to",
  "duedate": "Due date",
  "meetingforToday": "Meeting For Today",
  "mymeeting": "My Meeting",
  "meetingTitle": "Meeting Title",
  "meetingdatetime": "Date & Time",
  "meetingloc": "Meeting Location",
  "meetingorg": "Organizer",
  "tasksDetails": "Tasks Details",
  
  "momcreator": "Mom Creater",
  "webRTC":"webRTC",
  "meetingDetails": "Meeting Details",
  "mom": "Minutes of Meeting",
  "viewProjects": "View Projects",
    "viewPdf": "View PDF",
    "viewPdfMom": "View PDF MOM",
     "viewDocuments": "View Documents",


  "empOverview": "Employee Overview",
  "todaymeeting" : "Today's Meeting",
  "today'stasks" : "Today's Tasks",
  "tasks" : "Tasks",
  "status" : "Status",
  "initiated" : "Initiated",
  "inProgress" : "In Progress",
  "deadline" : "Deadline",
  "completed" : "Completed",
  "priority" : "Priority",
  "high" : "High",
  "medium" : "Medium",
  "low" : "Low",
  "yourschedulefortheday" : "Your schedule for the day",
  "Itlookslikeyoudon'thaveanymeetingsscheduledatthemoment" : "It looks like you don’t have any meetings scheduled at the moment",
  "Itlookslikeyoudon'thaveanytasksassignedtoyourightnow.":"It looks like you don't have any tasks assigned to you right now.",
  "thetasksassignedtoyoufortoday" : "The tasks assigned to you for today",
  "recentprojects" : " Recent Projects",
  "theprojectsassignedtoyou" : " The Projects assigned to you.",
  "projects": "Projects",
  "myprojectcard": "My Project Card",
  "projectname": "Project Name",
  "description": "Description",
  "projmanager": "Project Manager",
  "teammembers": "Team Member",
  "startdate": "Start Date",
  "search" : "Search...",
  "enddate": "End Date",
  "duration": "Duration",
  "noproject": "No Project!!",
  "assignedTask": "Assigned Task",
  "assignto": "Assigned To",
  "assignby": "Assigned By",
  "inprogress": "In Progress",
  "confirmurPart": "Confirm Your Participation",
  "areYouSureToReject": "Are you sure you want to reject?",
  "noSignatureAvailable": "No signature available.",

  "yes": "Yes",
  "no": "No",
  "mayBe": "Maybe",
  "attendees": "Attendees",
  "notesTaker": "Notes Taker",
  "createmom": "Create MOM",
  "edit": "Edit",
  "cancelmeet": "Cancel Meeting",
  "nodocument": "No Document",
  "searchemployee" : "Search employee",
  "Selectanemployeetoviewtheirdetails":"Select an employee to view their details",
  "leavequotanotassigned" : "Leave quota not assigned",
  "sharecontact" : "Share contact",
  "leavequota" : "Leave Quota",
  "updateleavequota" : "update Leave Quota",
  "groupname"  : "Group Name",   
 "pressthebutton" : "Press the button to start speaking",
 "typeyourmessage" : "Type your message...",
  "raiseddate" : "Raised Date",
  "raisedby" : "Raised By",
  "requestercomments" : "Requester Comments",
  "writecomments" : "write Comments",
  "listeningvoice" : "Listening Voice",
  "speechhistory" : "Speech History",
  "Nospeechhistoryavailable" : "No speech history available",
  "typing" : "Typing...",
  "askanything" : "Ask anything, get your answer",
  "pleaseSelectLeaveTypes": "Please select leave types",
  "noChatHistory": "No chat history available for this user.",
  "timestamp": "Timestamp",


  
    "commands": "Commands",
    "postCommand": "Post Command",
    "markAsCompleted": "Mark as completed",
    "markAsInProgress": "Mark as In Progress",
    "backToInProgress": "Back to In Progress",
    "backToInitiated": "Back to Initiated",
    "createdBy": "Created By",



  "contentItems": {
    "item0": "Dashboard",
    "item1": "Smart Attendance",
    "item2": "Smart Service",
    "item3": "Request",
    "item4": "Meeting Calendar",
    "item5": "My Project",
    "item6": "My Tasks",
    "item7": "Smart Document",
    "item8": "Mom",
    "item9": "Payroll Report",
    "item10": "My Report",
    "item11": "Shared Folder",
    "item12": "Links & Videos",
    "item13": "Employee Directory",
    "item14": "Groups",
    "item15": "My Assets",
    "item16": "AI Note",
    "item17": "AI Document Engine",
    "item18": "BOT",
    "item19": "OCR & Scan",
    "item20": "Chat",
    "item21": "Smart IT Support",
    "item24" : "Announcement",
    "item25" : "AI PDF Generator",
    "contentItems": {
      "dashboard": "CEO Dashboard"
    },

    "item22":"WebRTC",
    "item23":"Holiday"
    
  },


  

  "ceoInboxItem": {
    "item1": "Mom",
    "item2": "Smart Document",
    "item3": "Smart Service",
  },


    "hrproduct": "HR & Productivity",
    "advanceai": "Advanced AI",
    "newDoc": "New Document",

  "titless": {
    "inbox": "Inbox",
    "sentItems": "Sent Items",
    "archive": "Archive",
    "allDocuments": "All Documents",
    "viewMore": "View More",
    "Approved": " Approved",
    "allrequest" : "All Request",
    "pending": "Pending",
    "rejected": "Rejected",
    "draft": "Draft",
    "allmom": "All Mom",
    "cc" : "CC"
  },

// task
  "titles": {
    "allTask": "All Task",
    "inProgressTask": "In Progress Task",
    "completedTask": "Completed Tasks",
    "pendingTask": "Pending Task",
    "overAllTask": "OverAllTask",
    "justin": "Just In",
  },

  // Project
  "titlesss": {
    "allProject": "All Project",
    "inProgress": "In Progress",
    "completed": "Completed",
    "pending": "Pending",
    "hold": "Hold",
  },

  // itsupport
  "titlessss": {
    "openTickets": "Open Tickets",
    "inProgress": "In Progress",
    "closed": "Closed",
    "allTickets": "All Tickets",
    "resolved" : "Resolved"
  },

  // ceoemploye
  "titlesssss": {
    "attendance":"Attendance",
    "meeting": "Meetings",
    "task": "Tasks",
    "request": "Request",
    "document": "Documents",
  },

  "translate" : {
    "payroll" : "Payroll",
    "payrollDashboard" : "Payroll Dashboard",
    "payrollDetails" : "Payroll Details",
    "choosepayrollPeriod" : "Choose Payroll Period",
    "PayrollReport" : "Payroll Report",
    "payrollsummary" : "Payroll Summary",
    "chooseperiod" : "Choose Period",
    "choosepayrollperiod" : "Choose payroll period"
    
  },

  "payrollDetails" : "Payroll Details",
  "payrollDashboard" : "Payroll Dashboard",
  "RejectDocumentDesk": "Reject Document desk",
  "ApproveDocumentDesk": "Approve Document desk",
  "ArchiveDocument": "Archive Document",
  "ApproveDocument": "Approve Document",
  "Approve": "Approve",
  "RejectDocument": "Reject Document",
  "NoUserFound": "No user found",
  "allProject": "All Project",
   "dashboard": "CEO Dashboard",


   "reopen" : "Reopen",
  "extractedText" : "Extracted Text",
  "askAnythingGetAnswer": "Ask anything and get your answer",
  "copy" : "Copy",
  "copied" : "Copied",
  "smartSupport": "Smart IT Support",
  "shareFolder": "Shared Folder",
  "smartDocument": "Smart Document",
  "viewDocument": "View Document",
  "signDocument": "Sign Document",
  "reviewDocument": "Review Document",
  "chartingAndDiagramming": "Charting and Diagramming",
  "selectChartType": "Select chart type",
  "describeChart": "Describe the chart you want to generate",
    "getCode": "Get code",
  "mermaidCode": "Mermaid code",
  "enterChartDescription": "Enter Chart description",
  "generatedImage": "Generated Image",
  "mermaidCodeWillAppearHere": "Mermaid code will appear here",
  "downloadImage": "Download image",
  "ticketreview" : "ticket review",
  "markasclosed" : "Mark as Closed",


  "newfolder": "New Folder",
  "goBack": "Go Back",
  "back": "Back",
  "minutesofMeeting": "Minutes of Meeting",
  "newMom": "New Mom",
  "mytask": "My Task",
  "allTask": "All Task",
  "newtasks": "New Task",
  "overalltask": "Over All Task",
  "createTask": "Create Task",
  "createproj": "Create Project",
  "viewMore": "View More",
  "meeting": "Meeting",
  "myTasks": "My Tasks",
  "smartServices": "Smart Services",
  "totalavailableleave" : "Total Available Leave",
  "period" : "Period",
  "review":"Review",
  "reviewMom": "Review MOM",
  "pdfMom": "PDF MOM",
  "entermeetingtitle" : "Enter meeting title",
  "entermeetingagenda": "Enter meeting agenda",
  "chooseemployee" :"Choose employee",
 "externalpeople" : "External people",
 "agenda" : "Agenda",
 "joinmeet" : "Join Meet",
"exteranlpeopleemail" : "External people email",
"entermeetinglocation" : "Enter meeting location",
"entermeetinglink" : "Enter meeting link",
"meetinglink" : "Meeting Link",
"selectmeetingnotestaker" : "Select meeting notes taker",
  "meetingCalendar": "Meeting Calendar",
  "ticketsDetails": "Tickets Details",
  "viewTickets": "View Tickets",
  "requestDetails": "Request Details",
  "task": "Task",
  "attendance" : "Attendance",
  "noMeetings": "No Meeting",
  "createmeet": "Create Meeting",
  "employeeId": "Emp Id",
  "dateofjoin": "DOJ",
  "qualification": "Qualification",
  "supervisor": "Supervisor",
  "annuallevbal": "Annual Leave Balance",
  "annualsickbal": "Annual Sick Leave Balance",
  "theme": "Themes",
  "changePass": "Change Password",
  "logOut": "Logout",
  "public": "Public",
  "private": "Private",
  "entertitle" : "Enter Title",
  "enterdescription" : "Enter Description",
  "newproject": "New Project",
  
  "editProjects": "Edit Projects",
    "notifications": "Notifications",
    "itSupport": "IT Support",
  "attendanceRep": "Attendance Report",
  "smartService": "Smart Service",
  "waitingforapproval" : "Waiting for approval",
  "selectmonth" : "Select Month",
  "currentmonth" : "Current Month",
  "previousmonth" : "Previous Month",
  "lastthreemonth" : "Last Three Months",
  "custom" : "Custom",
  "approvedat" :"Approved at",
  "rejectedat" :"Rejected at",
  "pending": "Pending",
  "forapproval": "For Approval",
  "approved": "Approved",
  "rejected": "Rejected",
  "reject": "Reject",
  "request": "Request",
     "chatBot": "ChatBot",
  "createTeam": "Create Team",
     "viewRequest": "View Request",
  "approverNotes": "Approver Notes",
  "newrequest": "New Request",
  "requestLeave": "Request Leave",
  "requestSickleave": "Request Sick Leave",
  "requestworkfromRemote": "Request-Work From Remote",
  "selectclockintime" : "Select Clock-In Time",
  "selectrequest" : "Select Request",
  "selectclockinlocation": "Select Clock-In Location",
  "selectclockouttime" : "Select Clock-Out Time",
  "selectclockoutlocation" : "Select Clock-Out Location:",
  "selectdate" : "Select Date",
  "requesttype" : "Request Type",
  "halfday" : "Half-day",
  "leavecategory" : "Leave Category",
  "fromdate": "From Date",
  "todate": "To Date",
  "selectfromdate": "Select From Date",
  "selecttodate": "Select To Date",
  "enterreason" : "Enter Reason",
  "selectcategory": "Select Category",
  "docSelected": "Document Selected",
  "*documentisMandatory": "*Document is Mandatory for sick leave more than two days",
  "others": "Others",
  "ocrscan": "OCR Scanner",
  "camera": "Camera",
  "gallery": "Gallery",
  "capture": "Capture",
  "casual": "Casual",
  "sick": "Sick",
  "leaverequest": "Leave Request",
  "publishdate" : "Publish Date",
"selectpublishdate" : "Select Publish Date",
"enterannouncementtitle" : "Enter Announcement Title",
"enterannouncementdescription" : "Enter Announcement Description",
"announcementDetails": "Announcement Details",
 "wfrRequest": "WFR Request",
    "editRequest": "Edit Request",
    "leaveHistory": "Leave History",



"NoPDFContent": "No PDF content available",
"Back": "Back",
"MobileViewingMessage": "For better viewing on mobile devices:",
"OpenPDF": "Open PDF",
"DownloadPDF": "Download PDF",
"YourSignature": "Your Signature:",
"ClearSignature": "Clear Signature",
"EnterYourComments": "Enter your comments",

  "close": "Close",
  "requestSubmitSucces": "Request submitted successfully!",
  "reason": "Reason",
  "approver": "Approver",
  "starttime": "Start Time",
  "endtime": "End Time",
  "fullday": "Full Day",
  "shortLeave": "Short Leave",
  "date": "Date",
  "newservice": "New Service",
  "inprogressProj": "In Progress Projects",
  "document": "Document",
  "reviewed": "Reviewed",
  "view": "View",
  "docHistory": "Document History",
  "relatedAttach": "Related Attachements",
  "relateddoc" : "Related Documents",
  "relatedmeet" : "Related Meetings",
  "relatedtasks" : "Related Tasks",
  "docComment": "Document Comments",
  "shareFolderView": "Shared Folder View",
  "upload": "Upload",
  "uploaddocument" : "Upload Document",
  "Formatpdf" : "Format should be in .pdf, .jpeg, .png less than 5MB",
  "Formatpdf2" : "Format should be in .pdf, .word, .doc less than 5MB",

  "linksandvideos": "Links and Videos",
  "newlinkvideo": "New Link & Video",
  "empDirectory": "Employee Directory",
  "editEmployee": "Edit Employee",
  "addMom": "Add MOM",
  "createMom": "Create MOM",
  "createWorkflow": "Create Workflow",
  "viewMom": "View MOM",
  "signMom": "Sign MOM",

  "groupteam": "Group / Team",
  "createGroup": "Create Group",
  "createEmployee": "Create Employee",
  "assets": "Assets",
  "createAsset": "Create Asset",
  "AInotes": "AI Notes",
  "AIPDFGenerator" : "AI PDF Generator",
  "startSpeaking": "Press the mic button and start speaking",
  "listening": "Listening",
  "notListening": "Not Listening",
  "smartitSupport": "Smart IT Support",
  "saveforlater" : "Save for later",
  "ConverttoPDF" : "Convert to PDF",
  "Converting" : "Converting...",
  "addAnnouncement": "Add Announcement",
  "employeeDetails": "Employee Details",
   "viewAssets": "View Assets",
   "updateChart": "Update Chart",



    "botHistory": "Bot History",
    "viewHoliday": "View Holiday",
  "holiday" : "Holiday",
  "addholiday" : "Add Holiday",
  "publicholiday" : "Public Holiday",
  "companyholiday" : "Company holiday",
  "leavetype" : "Leave Type",
  "selectleavetype" : "Select Leave Type",
  "selectoffice" : "Select Office",
  "ticketDetails": "Ticket Details",
  "openTickets": "Open Tickets",
  "open" : "Open",
  "closed": "Closed",
  "allTickets": "All Ticets",
  "tickets": "Tickets",
  "noTickets": "No Tickets",
  "createTickets": "Create Tickets",

  "remark": "Remark",
  "remarkCannotbeempty": "لا يمكن أن تكون الملاحظة فارغة",
  "newTicket": "New Ticket",
  "attachments": "Attachments",
  "title": "Title",
  "noFiles": "No Files",
  "browse": "Browse",
  "cancel": "Cancel",
  "submit": "Submit",
  "addTickets": "Add Tickets",
  "newMeeting": "New Meeting",
  "newemployee": "New Employee",

  "subject": "Subject",
  "repeat": "Repeat",
  "everyMonday": "Every Monday",
  "everyTuesday": "Every Tuesday",
  "everyWednesday": "Every Wednesday",
  "everyThursday": "Every Thursday",
  "everyFriday": "Every Friday",
  "noteTaker": "Note Taker",
  "link": "Link",
  "time": "Time",
  "from": "From",
  "to": "To",
  "send": "Send",
  "Position": "Position",
  "groupInfo": "Group Info",
  "actionPlan": "Action Plan",
  "linkedproject": "Linked Project",
  "assignTask": "Assign Task",
  "workFlow": "Work Flow",
  "projtitle": "Project Title",
  "enterprojecttitle" : "Enter Project Title",
  "enterprojectdescription" : "Enter Project Description",
  "projectmanager" : "Project Manager",
  "nameoftheclient" : "Name of the Client",
  "selecttechstack" : "Select Tech Stack",
  "clientname": "Client Name",
  "techStack": "Technical Stack",
  "create": "Create",
  "nameTeamMembers": "Name of the Team Members",
  "nameProjManager": "Name of the Project Manager",
  "id": "ID",
  "reviewedby": "Reviewed By",
  "signby": "Sign By",
  "Documentid" : "Document Id",
  "reviewer" : "Reviewer",
  "preparedby": "Prepared by",
  "selectproject" : "Select Project",
  "selectemployee": "Select Employee",
  "files" : "Files",
  "purpose" : "Purpose",
  "discussionpoints" : "Discussion Points",
  "employee": "Employee",
  "team": "Team",
  "member": "Member",
  "cc": "CC",
  "save": "Save",
  "editmeeting": "Edit Meeting",
  "selectedEmployees": "Selected Employees",
  "selectEmployees": "Select Employees",
  "assignEmployees": "Assign Employees",
  "employees": "Employees",
  "noactionreq": "No Action Required 👍",
  "updateMeeting": "Update Meeting",
  "UpdateProject": "Update Project",
  "progress": "Progress",
  "hold": "Hold",
  "update": "Update",
  "editTask": "Edit task",
  "taskDetail": "Task details",
  "through": "Through",
  "forInfo": " For Information",
  "forAction": " For Action",
  "forApprove": "For Approval",
  "choosepurpose" : "Choose Purpose",
  "preview": "Preview",
  "newSharedFolder": "New Shared Folder",
  "whocanacess": "Who can Access",
  "access" : "Acesss",
  "newLink&Video": "New Link & Video",
  "newTeam": "New Team",
  "groupName": "Group Name",
  "newAssets": "New Assets",
  "searchassets" : "Search Assets",
  "assetname" : "Assets Name",
  "assetsinfo" : "Assets Info",
  "devicename" : "Device Name",
  "brand" : "Brand",
  "enterserialnumber" : "Enter Serial No",
  "enterproductname" : "Enter Product Name",
  "enterproductvalue" : "Enter Product Value",
  "serialno": "Serial No",
  "productname": "Product Name",
  "productvalue": "Product value",
  "smartAttendance": "Smart Attendance",
  "viewallemp": "View More Employee",
  "report": "Report",
  "attendancereport": "Attendance Report",
  "norequest": "No requests ",
  "norequestsubmitted" : "No Request Submitted!",
  "Itsallclear" : "It's all clear for now. Add something new to fill this area",
  "clearall" : "Clear All",
  "enterlink" : "Enter Link",
  "norecordsfound" : "No Records Found",
  "users": "Users",
  "payroll": "Payroll",
  "payrollReport": "Payroll Report",
  "selectMonth" : "Select Month",
  "select": "Select",
  "generate": "Generate",
  "generatereport" : "Generate Report",
  "selecttime": "Select a Time",
  "remote": "Remote",
  "office": "Office",
  "selectrange" : "Select Range",
  "totalhours" : "Total Hours",	
  "clockin&out" : "Clock In & Out",
  "clockinlocation" : "Clock in Location",
  "clockoutlocation" : "Clock out Location",
  "forgetClockin&out": "Forget To Clock-In and Clock-Out",
  "clockOutConfirm": "Clock Out Confirmation",
  "clockInConfirm": "Clock In Confirmation",
  "AreyouwanttoClockOut": "Are you sure you want to Clock Out?",
  "AreyouwanttoClockIn": "Are you sure you want to Clock In?",
  "forgotclckin&out": "Forgot Clock In / Out",
  "timezonechange": "Time Zone Change",
  "timezone": "Time Zone",
  "notes": "Notes",
  "newchat": "New Chat",
  "selectTimeZone":"Select Time Zone",
  "home": "Home",
  "service": "Service",
  "BOT": "BOT",
  "chat": "Chat",
  "notify": "Nofication",
  "Swipetoclockout": "Swipe here to clock out",
  "Swipetoclockin": "Swipe here to clock in",
  "accepted" : "Accepted",
  "maybe": "May be",
  "payrollSummary": "Pay Roll Summary",
  "Tasks": "Tasks",
  "Meetings": "Meetings",
  "Smart Document": "Smart Document",
  "projecttask": "Project Task",
  "remainingdays": "Remaining Days",
  "speech": "Speech",
  "history": "History",
  "reset": "Reset",
  "aidocumentengine": "AI Document Engine",
  "chathistory": "Chat History",
  "assigntickets" : "Assign Tickets",
  "enterremark" : "Enter Remark",
  "choosepriority" : "Choose Priority",
  "closeddate" : "Closed Date",
  "secondresponse" : "Second Response",
  "firstresponse" : "First Response",
  "closedresponse" : "Closed Response",
  "SLADate" : "SLA Date",
  "Signed": "Signed",
  "Reviewed": "Reviewed",
  "Archived": "Archived",
  "Announcement": "Announcement",
  "CreateAnnouncement": "Create announcement",
  "EnteremployeeID": "Enter employee ID",
  "Name": "Name",
    "Designation": "Designation",
  "Email": "Email",

  "PleaseSelectDocument": "Please select document",
  "profileDetails": "Profile Details",
  "changePassword": "Change Password",


    "profile": "Profile",
    "accounts": "Accounts",
    "language": "Language",
    "signature": "Signature",
    "preferences": "Preferences",
    "aboutApp": "About APP",
    "themeMode": "Theme mode",
    "feedbackSuggestion": "Feedback/Suggestion",
    "change": "Change",
    "remove": "Remove",
    "viewSignature": "View Signature",
    "replaceSignature": "Replace Signature",
    "clear": "Clear",

    "message": "Message",
      "viewSmartService": "View Smart Service",
  
  


  "EnterEmployeeName": "Enter Employee Name",
  "Gender": "Gender",
  "Male": "Male",
  "Female": "Female",
  "EnterEmailAddress": "Enter Email Address",
  "EnterDesignation": "Enter Designation",
  "Number": "Number",
  "Role": "Role",
  "SelectRole": "Select Role",
  "HR": "HR",
  "Manager": "Manager",
  "Employee": "Employee",
  "SelectTimeZone": "Select Time Zone",
  "TimeZone": "Time Zone",
  "Office": "Office",
  "SelectLeaveTypes": "Select Leave Types",
  "LeaveTypes": "Leave Types",
  "Days": "Days",
  "Reporter": "Reporter",
  "ReportTo": "Report to",
  "SearchTeamName": "Search Team Name",
  "Members": "Members",
  "EditTeam": "Edit Team",
  "ViewTeam": "View Team",
  "DeleteTeam": "Delete Team",
    "GroupName": "Group Name",
  "SelectEmployees": "Select Employees",
  "teamname": "Team Name",

  

  // warning message
  "Pleaseenterafromdate" : "Please enter a from date",
  "Pleaseenterareason" : "Please enter a reason",
  "Pleaseenteratodate" : "Please enter a to date",

  "PleaseenteraleaveType"   : "Please enter a leaveType",
  "Pleaseenteratitle": "Please enter a title",
  "Pleaseselectemployees": "Please select employees",
  "Pleaseselectadate": "Please select a date",
  "PleaseselectClockintime": "Please select Clock in time",
  "PleaseselectaClockOuttime": "Please select a Clock Out time",
  "Pleaseselecttimezone": "Please select timeZone",


  "Pleaseselectadescription": "Please enter a description",
  "PleaseselectprojectManager": "Please select project Manager",
  "PleaseselectTeamMembers": "Please select Team Members",
  "PleaseselectaStartdateoftheproject": "Please select a Start date of the project",
  "PleaseselectaEnddateoftheproject": "Please select a End date of the project",
  "PleaseenterclientNameoftheproject": "Please enter clientName of the project",
  "PleaseEnterSerialNo": "Please enter Serial No",
  "PleaseEnterProductName": "Please enter a Product Name",
  "PleaseEnterProductValue": "Please enter a Product Value",

    "PleaseenteremployeeID": "Please enter employee ID",
    "Pleaseenterthename": "Please enter the name",
    "Pleaseentertheposition": "Please enter the position",
    "Pleaseenterthenumber": "Please enter the number",
    "Pleaseselectthegender": "Please select the gender",
    "Pleaseselecttherole": "Please select the role",
    "Pleaseselecttheofficelocation": "Please select the office location",
    "Pleaseselectthereporter": "Please select the reporter",
    "PleaseselecttheTimeZone": "Please select the Time Zone",
    "Pleaseselecttheleavetypes": "Please select the leave types",
    "Pleaseenteremail": "Please enter email",

      "PleaseEnterATeamName": "Please enter a Team Name",
  "PleaseSelectEmployees": "Please select employees",
    "PleaseSelectPriority": "Please select priority",
  "PleaseEnterRemark": "Please enter remark",
  "PleaseEnterLink": "Please enter link",
  "NoUsersAreCurrentlyClockedIn": "No users are currently clocked in",
    "pleaseEnterSubject": "Please enter subject",
  "pleaseEnterMessage": "Please enter message",
  






  };

export default enTranslations;
